module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm1_en.4f9a2ebf1870088094af41867d54eb73.png";